import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeatureService } from "../../service/FeatureService";
const initialState = {
    loading: false,
};
const action = {
    create: createAsyncThunk("feature/create", async (payload, thunkAPI) => {
        return (await FeatureService.create(thunkAPI, payload.data)).data;
    }),
};
const slice = createSlice({
    name: "feature",
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.create.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        });
    },
});
export const feature = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
